export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";